import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import {
  Button,
  Grid,
  makeStyles
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  }
});

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 15,
  },
  vælglabel: {
    fontSize: 18,
  },
  textFieldNumber: {
    fontSize: 18,
    width: 70,
    height: 50,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: '#FFFFFF',
    margin: theme.spacing(1),
    marginTop: -10,
  },
  dialog: {
    position: 'absolute',
    top: 150,
    height: 280,
  },
  errors: {
    color: '#FF4949',
    fontSize: '15px'
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h5">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: "#252525",
  },
}))(MuiDialogActions);

export default function CustomizedDialogs({ modalShow, modalState, item, setDurationCallback }) {
  const classes = useStyles();
  const [open, setOpen] = useState(modalShow);
  const [errorMessage, setErrorMessage] = useState('');
  const [durationSecs, setDurationSecs] = useState(0);


  useEffect(() => {
    let displayDurationSecs = converthhmmssToSecs(item.displayDuration);
    setDurationSecs(displayDurationSecs);
  }, [])

  const convertSecsTohhmmss = (value) => {
    value = parseInt(value);
    if (value === 0)
      return '00:00:00'
    let displayDuration = new Date(value * 1000).toISOString().substr(11, 8);
    return displayDuration;
  }

  const converthhmmssToSecs = (value) => {
    let displayDurationSecs = 0;
    if (value === '00:00:00' || value === undefined)
      displayDurationSecs = 0;
    else {
      const [hours, minutes, seconds] = value.split(':');
      displayDurationSecs = Number(hours) * 60 * 60 + Number(minutes) * 60 + Number(seconds);
    }
    return displayDurationSecs;
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    modalState(false);
    // setOpen(false);
  };

  const handleSave = () => {
    let newDisplayDuration = convertSecsTohhmmss(durationSecs);
    let newDurationItem = item;
    newDurationItem.displayDuration = newDisplayDuration;
    setDurationCallback(newDurationItem);
    handleClose();
  }

  const handleDurationChange = (e) => {
    let durationSecs = e.target.value;
    if (durationSecs < 0)
      return;

    setDurationSecs(e.target.value);
  }

  return (
    <div >
      <Dialog className={classes.dialog}
        TransitionComponent={Transition}
        disableBackdropClick={true}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}  >
        <DialogTitle className="dialog-modal-title" id="alert-dialog-slide-title">{"Angiv varighed"}</DialogTitle>
        <DialogContent dividers className="dialog-modal-content" >
          <Grid container item justify="center" lg={12} xs={12} md={12}>
            <form noValidate autoComplete="off" /* classNamme={classes.root} */>
              <label className={classes.vælglabel} > Vælg varighed:
                <TextField
                  id="duration"
                  className={classes.textFieldNumber}
                  type="number"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={durationSecs}
                  onChange={handleDurationChange}
                  min="0"
                  step="1"
                /> Sekunder</label>
            </form>
          </Grid>
          {
            errorMessage === '' ? '' :
              <span className={classes.errors}>{errorMessage}</span>
          }
        </DialogContent>
        <DialogActions >
          <Button variant="contained" color="default" onClick={handleClose} >
            Fortyrd
          </Button>
          <Button classname="button-color" className="color-changer" variant="contained" onClick={handleSave} >
            Gem
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
